import { PASTEL_PURPLE, VIVID_PURPLE } from '../../styles/colors';
import styled from 'styled-components';

// Styled components
export const StepBarContainer = styled.div`
  display: flex;
  width: 100%;
  gap: 1.2vw;
  padding: 0 16px;
  margin: 16px 0;
` as any;

interface StepProps {
  $completed: boolean;
}

export const Step = styled.div<StepProps>`
  flex: 1;
  height: 8px;
  border-radius: 4px;
  background-color: ${(props) =>
    props.$completed
      ? VIVID_PURPLE
      : PASTEL_PURPLE
  };
  transition: background-color 0.3s ease;
` as any;
